/**
 * @generated SignedSource<<460236f507bc70a468c237945cf6631e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTestObjectMutation$variables = {
  id: string;
  name: string;
};
export type UpdateTestObjectMutation$data = {
  readonly updateTestObject: {
    readonly id: string;
    readonly name: string;
  };
};
export type UpdateTestObjectMutation = {
  response: UpdateTestObjectMutation$data;
  variables: UpdateTestObjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TestObject",
    "kind": "LinkedField",
    "name": "updateTestObject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTestObjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateTestObjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fb3c00a467633c025614f28a376d5d4a",
    "id": null,
    "metadata": {},
    "name": "UpdateTestObjectMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTestObjectMutation(\n  $id: ID!\n  $name: String!\n) {\n  updateTestObject(input: {id: $id, name: $name}) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "d23e518073465d96afa3152fae5be7f7";

export default node;
